import { ENV } from "../../constants/env";
import { toFormatLatinName } from "./strings";

export const nameMaskFunction = value => {
    if (!value || value === " ") {
        return "";
    }
    const nameValue = value.replace(/ {2}/g, " ");
    const formattedLatinNameValue = toFormatLatinName(nameValue, true);
    return `${formattedLatinNameValue}`;
};

export const getDocumentFormat = (documentId, documentType) => {
    if (documentType === "CE") return documentId.replace(/^(0+)/g, "");
    return documentId;
};

export const getIdDocumentType = documentType => (documentType === "DNI" ? "1" : "3");

export const formatDateToCrmOracle = date => {
    const [dateWithoutHours] = date.toISOString().split("T");
    return dateWithoutHours;
};

export const clientTypeTranslate = type => {
    const client = {
        OWNER: "propietario",
        TENANT: "inquilino",
    };
    return client[type] || null;
};

export const ensureTranslate = type => {
    const ensure = {
        HOME: "casa",
        ALL: "casa_cosas",
        BELONGINGS: "cosas",
    };
    return ensure[type] || null;
};

export const housingTypeTranslate = type => {
    const housing = {
        HOUSE: "casa",
        DEPARTMENT: "departamento",
    };
    return housing[type] || null;
};

export const isAForm = Number(ENV.REACT_APP_IS_A_FORM) === 1 ? true : false;